module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAM1BMVEUAAADv+/jv+/jv+vjv+/jv/+/v/Pnv/fjt+ffv9/fv+/jt+ffs+vfv+fXv+/iB2NG46eQGxMGhAAAADnRSTlMA76/fjxCfb0Agz4BgUIpAA3gAAADvSURBVDjLndXbsoMgEETRHkYFbx3//2vPiWUVIQ3BZD/kxVVMChVRlmJYjDQPMaHZPDlfsnVsML5nQ4Vuzkq2v7uBjYaCjYHNwuv4womUud3pOztt1x+0NjmO56/PvcHH43HKSRYUd8nnkutnl5e0G44OpK47S4i3HCPCLccAzzv2wXGB5R1TlzMUOyYuB7kk7oImF6vOsJTjGo6OwFLWHQMiS1l3jEhUqY4JcJEVZwAmfQC1FcAsj7RmI/KScsvlPZydkix4tvXg/t0B0D9Sfjmk+sdebrca8w3SOCidZtQa14J6wfTz4f/aFvl8/AHblURPhG9KRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/check1.png
// module id = 569
// module chunks = 0